import { Component, Injector, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AbstractComponent } from 'lib-trend-core';
import { Constants } from '../../../environments/constantes';
import { AboutModalComponent } from './about-modal/about-modal.component';

@Component({
    selector: 'footer-component',
    templateUrl: './footer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FooterComponent extends AbstractComponent {

  readonly currentYear: number = new Date().getFullYear();
  readonly supportUrl: string = Constants.supportWhatsappUrl;
  readonly statusPageUrl: string = Constants.statusPageUrl;

  constructor(
    injector: Injector,
    private readonly dialog: MatDialog,
  ) {
    super(injector);
  }

  openAboutModal(): void {
    this.dialog.open(AboutModalComponent, {
      width: '380px',
    });
  }

  goToKnowledgeBase(): void {
    this.router.navigate(['/support']);
  }

}
